/* eslint-disable @typescript-eslint/no-require-imports */
import type { LoggingService } from "$src/core/services/logging/logging";
import CustomPlatform from "$src/core/utils/platform/platform";

export default CustomPlatform.select<() => LoggingService>({
  web: () => require("./sentry.web").default,
  default: () => require("./sentry").default,
})();
